<template>
<div>
  <div class="card">
    <div class="card-header">Venta</div>
<br>

 <div class="form-group row">
     
      <label class="col-sm-2 col-form-label" style="margin-left:15px">Folio :</label>
      <div class="col-sm-2">
        <input
          type="nombre"
          v-model="folio"
          class="form-control"
          @keyup.enter="verVentas(folio)"
          placeholder="Presione Enter!"
        >

      </div>
         <label class="col-sm-3 col-form-label" style="font-size:12px">Ingrese Folio y Presione Enter</label>
      <h2>{{cliente.nombre+" "+cliente.apellido}}</h2>
 </div>

 <div class="form-group row" v-if="lista_ventas.length>0">
     <div class="col-md-4" style="margin-left:15px">
     <button class="btn btn-danger" v-if="permiso==1" @click="eliminarVenta(folio)">Cancelar Venta</button>
     </div>
      <div class="col-md-4" style="margin-left:15px">
     <button class="btn btn-success" v-if="permiso==1" @click="reactivarVenta(folio)">Reactivar Venta</button>
     </div>
 </div>

 

          <div class="table-responsive">
            <table class="table table-striped">
              <tr>
                   <th>Folio</th>
                  <th>Fecha</th>
                <th @click="sort('Cantidad')">Cantidad</th>
                
                <th @click="sort('producto')">Producto</th>

                <th @click="sort('precio')">PU</th>
                <th @click="sort('total')">PT</th>
                <th>Método de Pago</th>
                <th>Estado</th>
              </tr>
              <tbody v-if="lista_ventas.length>0">
                <tr v-for="(obj,index) in sortedVentas" :key="index">
                     <td>{{obj.folio}}</td>
                    <td>{{obj.fecha}}</td>
                  <td>{{obj.cantidad}}</td>
                 
                  <td>{{obj.producto}}</td>

                  <td>{{obj.precio}}</td>
                  <td>{{obj.precio*obj.cantidad}}</td>
                  <td>{{obj.tipoventa}}</td>
                    <td>{{obj.estado}}</td>


                  <td>
                  <!--  <a
                      style="color: gray;cursor:pointer"
                      class="fa fa-search"
                      @click="verAbonos(obj.idcliente,obj.nombre+' '+obj.apellido)"
                    ></a>-->
                   
                    <a
                      v-if="permiso==1 && obj.estado=='VIGENTE'"
                      style="color: red;cursor:pointer"
                      class="fa fa-trash"
                      @click="eliminarProducto(obj,folio)"
                    ></a>
                      <a
                      v-if="permiso==1 && obj.estado=='CANCELADO'"
                      style="color: green,cursor:pointer"
                      class="fa fa-check"
                      @click="reactivarProducto(obj,folio)"
                    ></a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
           </div>
        <!--  <button @click="prevPage">Anterior</button>
          <button @click="nextPage">Siguiente</button>-->
       
     

      
    
  </div>
</template>
<script>
import { url } from "../main.js";
import { Datetime } from "vue-datetime";
import { CoolSelect } from 'vue-cool-select';
export default {
  data() {
    return {
        f:{},
        folio:"",
     lista_ventas:[],
     cliente:{
 nombre:"",
 apellido:""
     },
      permiso: 0,
      currentSort: "",
      currentSortDir: "",
      pageSize: 10,
      currentPage: 1,
     
     
    };
  },
   components: {
    datetime: Datetime,
     CoolSelect
  },
  mounted() {
    this.permiso = localStorage.getItem("permission");
    
  },
  computed: {
    sortedVentas() {
     
          return this.lista_ventas
            .sort((a, b) => {
              let modifier = 1;
              if (this.currentSortDir === "desc") modifier = -1;
              if (a[this.currentSort] < b[this.currentSort])
                return -1 * modifier;
              if (a[this.currentSort] > b[this.currentSort])
                return 1 * modifier;
              return 0;
            })
            .filter((row, index) => {
              let start = (this.currentPage - 1) * this.pageSize;
              let end = this.currentPage * this.pageSize;
              if (index >= start && index < end) return true;
            });
        }
      
    },


  methods: {
     
  verVentas(folio){
    this.cliente.nombre='';
    this.cliente.apellido='';
       this.axios
        .get(url + "apiVentas.php/get_ventas/"+folio)
        .then(respuesta => {
          console.log(respuesta);
          this.lista_ventas = respuesta.data;
this.cliente.nombre=this.lista_ventas[0].nombre;
this.cliente.apellido=this.lista_ventas[0].apellido;
          console.log(this.lista_ventas);
          folio="";
        })
        .catch(function() {
          console.log("FAILURE ver!!");
        });

  },
    eliminarVenta(folio){
        this.f={};
        this.f.folio=folio;
        this.f.lista_ventas=this.lista_ventas;
        this.$swal({
        title: "Confirmación",
        text: "¿Desea cancelar la venta?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "No",
        confirmButtonText: "Sí, cancelar"
      }).then(result => {
        if (result.value) {
          this.$http
            .post(url + "apiVentas.php/cancelar_venta",this.f)
            .then(respuesta => {
              console.log(respuesta);

              if (respuesta.data.status === 200) {
                this.$swal("Venta Cancelada");
                this.verVentas(folio);
              }
            });
        }
      });

    },
      reactivarVenta(folio){
        this.f={};
        this.f.folio=folio;
        this.f.lista_ventas=this.lista_ventas;
       
          this.$http
            .post(url + "apiVentas.php/reactivar_venta",this.f)
            .then(respuesta => {
              console.log(respuesta);

              if (respuesta.data.status === 200) {
                this.$swal("Venta Reactivada");
                this.verVentas(folio);
              }
            });
        
      

    },
    eliminarProducto(ventaproducto,folio){
      console.log(ventaproducto);
        this.f.id=ventaproducto.id;
        this.f.cantidad=ventaproducto.cantidad;
        this.f.pt=ventaproducto.cantidad*ventaproducto.precio;
        this.f.idcliente=ventaproducto.idcliente;
        this.f.idproducto=ventaproducto.idproducto;
        this.f.tipoventa=ventaproducto.tipoventa;
        this.f.estatus=ventaproducto.estatus;
        this.$swal({
        title: "Confirmación",
        text: "¿Desea cancelar el producto?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "No",
        confirmButtonText: "Sí, cancelar"
      }).then(result => {
        if (result.value) {
          this.$http
            .post(url + "apiVentas.php/cancelar_producto",this.f)
            .then(respuesta => {
              console.log(respuesta);

              if (respuesta.data.status === 200) {
                this.$swal("Producto Cancelado");
                this.verVentas(folio);
              }
            });
        }
      });

    },
     reactivarProducto(ventaproducto,folio){
      
          this.f.id=ventaproducto.id;
        this.f.cantidad=ventaproducto.cantidad;
        this.f.pt=ventaproducto.cantidad*ventaproducto.precio;
        this.f.idcliente=ventaproducto.idcliente;
        this.f.idproducto=ventaproducto.idproducto;
        this.f.tipoventa=ventaproducto.tipoventa;
        this.f.estatus=ventaproducto.estatus;
       
          this.$http
            .post(url + "apiVentas.php/reactivar_producto",this.f)
            .then(respuesta => {
              console.log(respuesta);

              if (respuesta.data.status === 200) {
                this.$swal("Producto Reactivado");
                this.verVentas(folio);
              }
            });
        }
      

    
    
    
   
  }
};
</script>



// WEBPACK FOOTER //
// src/views/venta.vue